import { render } from "./welcome.html?vue&type=template&id=17fd308b&external"
import script from "./welcome.js?vue&type=script&lang=js&external"
export * from "./welcome.js?vue&type=script&lang=js&external"

import "./welcome.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__